import React, {useEffect, useState} from 'react'
import { HideShow } from './HideShow';
import { FormattedMessage, useIntl } from 'react-intl';
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle';
import { businessTypes } from 'sr/i18n/messages/setting';
export const Filter = ({HandleFilterData = null, business_type}) => {
  const intl = useIntl()
  const [show, setShow] = useState(false)
  const [businessType, setBusinessType] = useState([])
  const [location, setLocation] = useState('')
    const toggleShow = () =>{
        setShow(!show)
    }
    useEffect(()=> {
    const filter = {
      business_type:businessType

    }
    HandleFilterData(filter)
    },[businessType])

useEffect(() => {
  if (JSON.stringify(businessType) !== JSON.stringify(business_type)) {
    setBusinessType(business_type);
  }
}, [business_type]);

  const businessTypeOptions = businessTypes.map((b) => ({
    value: b.value,
    label: intl.formatMessage({ id: b.label, defaultMessage: b.label }),
  }));

  return (
    <div className='bg-white p-6 rounded-[20px] shadow-sm shadow-slate-300 w-full mb-5'>
    <div className='font-bold py-4 border-b-[1px]	'>
      <FormattedMessage 
      id='CLEANER.JOBS.FILTER.TITLE'
      defaultMessage='All Filter'
      />
    </div>
    <HideShow viewmore={true} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.BUSINESSTYPE', defaultMessage:'Business Type'})} data={businessTypeOptions} newData={businessType}  onChange={(e:any) => CheckBoxHandle(e, businessType, setBusinessType )} />    
      {/* <HideShow SearchShow = {true} Title = {intl.formatMessage({id:'CLEANER.JOBS.FILTER.LOCATION', defaultMessage:'Location'})} searchPlaceholder={intl.formatMessage({id:'CLEANER.JOBS.FILTER.LOCATION.SEARCH.PLACEHOLDER', defaultMessage:'Search Location'})} data={usaCities} newData={location} onChange={(e:any)=> CheckBoxHandle(e, location, setLocation)}/> */}
 
</div>
  )
}
